import { Routes, Route, useNavigate } from 'react-router-dom'
import styles from '../../../pages/LeadCapture/ExhibitorList/ExhibitorList.module.css'
// Font Awesome assets
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCogs } from '@fortawesome/free-solid-svg-icons'
// image elements
const cog = <FontAwesomeIcon icon={faCogs} />


const LCExhibitor = ({ exhibitorItem }) => {
    const navigate = useNavigate()
    return (
        <>
            <tr className={styles.trAccounts}>
                <td className={styles.tdEvents}> {exhibitorItem.refNumber}</td>
                <td className={styles.tdEvents}> {exhibitorItem.firstName}</td>
                <td className={styles.tdEvents}> {exhibitorItem.lastName}</td>
                <td className={styles.tdEvents}> {exhibitorItem.passcode}</td>
                <td className={styles.tdEvents}> {exhibitorItem.organization}</td>
                <td className={styles.tdEvents}> {exhibitorItem.email}</td>
                <td className={styles.tdEvents}>
                    <button className={styles.editButton} onClick={e => navigate(`/ExhibitorManager`, { state: exhibitorItem })} title="Exhibitor settings.">
                        <i className={styles.buttonImage}>{cog}</i>
                    </button>
                </td>
            </tr>

        </>
    );
}

export default LCExhibitor;